import Axios, { AxiosInstance } from "axios";
import router from "@/router";
import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import authHeader from "@/common/qAuthHeader";
import store from "@/store";

class api {
  public http: any;
  public loader: any;

  getHttp(): AxiosInstance {
    return this.http;
  }

  post($path, parameters: any = {}, retryCount = 5) {
    // todo change value
    let body = {
      request_token: uuidv4(),
      customer_token: store.state.SystemStore.system.customer_token,
    }

    if (parameters !== []) {
      body = { ...body, ...parameters}
    }
    const request = async () => {
      return await this.getHttp().post<any>($path, body).catch((error) => {
        if (error.response?.status === 401) {
          router.replace({ name: "error" });
          return null;
        } else if (error.response?.status === 423) {
          router.replace({ name: "locked" });
          return null;
        } else {
          throw error;
        }
      });
    }
    return this.retry(request, retryCount)
      .catch((error) => {
        const errorMessage = error.response?.data?.message || error.message;
        router.replace({ name: "error" , query: { errorMessage }});
        return {};
      });
  }
  retry(fanction_, retries=3, error=null) {
    if (!retries) {
      return Promise.reject(error);
    }
    return fanction_().catch(error => {
      return this.retry(fanction_, (retries - 1), error);
    });
  }

  setup(): void {
    // set basic url or token
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      baseURL: process.env.VUE_APP_API_URL,
    };

    this.http = Axios.create(config);
    this.http.interceptors.request.use(
      (config: any) => {
        const token = authHeader();
        this.loader && this.loader.hide();
        if (!(config.data && config.data.notLoading)) {
          this.loader = Vue.$loading.show({});
        }
        if (token.Authorization) {
          config.headers = { ...config.headers, ...token };
        }
        return config;
      },
      (error: any) => {
        this.loader && this.loader.hide();
        // Do something with request error
        return Promise.reject(error);
      }
    );
    this.http.interceptors.response.use(
      (response: any) => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        this.loader && this.loader.hide();
        return response;
      },
      (error: any) => {
        this.loader && this.loader.hide();
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
      }
    );
  }
}

export default api;
